<template>
  <section class="personal-page">
    <div class="container">
      <div class="row align-items-center justify-content-center">
        <div class="col-xl-6 col-lg-7 col-sm-12 col-12 fxt-bg-color">
          <div class="fxt-content Larger shadow">
            <div class="fxt-header">
              <div class="page-content">
                <header id="site_header" class="header mobile-menu-hide">
                  <div class="header-content">
                    <div class="header-photo">
                      <img
                        src="../assets/img/profile-pic-2-alt-2025.jpg"
                        alt="Thiago Sousa"
                      />
                    </div>
                    <div class="header-titles">
                      <h2>Thiago Sousa</h2>
                      <h4>Hello, World!</h4>
                    </div>
                  </div>
                  <div class="social-links">
                    <ul>
                      <li>
                        <a
                          href="https://www.linkedin.com/in/thiagosousadev"
                          target="_blank"
                          ><i class="fab fa-linkedin-in"></i
                        ></a>
                      </li>
                      <li>
                        <a
                          href="https://github.com/ThiagoSousaDEV"
                          target="_blank"
                          ><i class="fab fa-github"></i
                        ></a>
                      </li>
                      <li>
                        <a
                          href="https://www.behance.net/thiagosousadev"
                          target="_blank"
                          ><i class="fab fa-behance"></i
                        ></a>
                      </li>
                      <li>
                        <a
                          href="mailto:contato@thiagosousadev.net"
                          target="_blank"
                          ><i class="fas fa-envelope"></i
                        ></a>
                      </li>
                    </ul>
                  </div>
                </header>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PersonalPage",
};
</script>
